export default class Amenity {
    title = '';
    description = '';
    group = 'standard';
    type = null;
    open_in_new_tab = false;
    url = null;
    media = null;
    media_item = null;

    constructor(data) {
        this.title = data?.title ?? this.title;
        this.description = data?.description ?? this.description;
        this.group = data?.group ?? this.group;
        this.type = ((data?.type && this.types.includes(data.type)) ? data.type : null) ?? this.type;
        this.open_in_new_tab = data?.open_in_new_tab ?? this.open_in_new_tab;
        this.url = data?.url ?? this.url;
        this.media = data?.media ?? this.media;
        this.media_item = data?.media_item ?? this.media_item;
    }

    get groups() {
        return [
            'standard',
            'open'
        ]
    }

    get types() {
        return [];
    }

    get icons() {
        return [
            'fak fa-bank',
            'fak fa-beer',
            'fak fa-boat',
            'fak fa-bulb',
            'fak fa-car',
            'fak fa-coffee',
            'fak fa-community',
            'fak fa-fire',
            'fak fa-golf',
            'fak fa-help',
            'fak fa-kettlebell',
            'fak fa-keys',
            'fak fa-lawn-mower',
            'fak fa-rower',
            'fak fa-school',
            'fak fa-shield',
            'fak fa-soccer-field',
            'fak fa-weight'
        ]
    }

    get medias() {
        return [
            'image',
            'video'
        ]
    }
}